import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import Paper from "commons/ui/Paper";

import useTemplateForm from "hooks/form/useTemplateForm";

function TemplateForm({ templateId }: { templateId?: string }) {
    const { formHook } = useTemplateForm({ templateId });

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridItem>
            <GridRow>
                <GridItem className={"col-xs-12-12"}>
                    <Paper>
                        <GridColumn>
                            <GridRow>
                                <GridItem className={"title-margin"}>
                                    <h1>Template</h1>
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-12"}>
                                    <InputText
                                        label={"Nome del template"}
                                        setValue={setValue}
                                        value={form.name}
                                        path={"name"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>
                        </GridColumn>
                    </Paper>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

export default TemplateForm;
